// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import OverflowMenuPresentationPropsDefault from "@insite/mobius/OverflowMenu/presentationProps";
import { xBaseTheme } from "@rugby/XDL/types";
import { color } from "@rugby/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...OverflowMenuPresentationPropsDefault,
        buttonProps: {
            ...OverflowMenuPresentationPropsDefault?.buttonProps,
            mergeCss: true,
            size: 40,
            css: css`
                position: relative;

                &:hover {
                    span[class^="IconWrapper"] {
                        color: ${color("common.white")};
                    }
                }
            `,
        },
        iconProps: {
            css: css`
                &&& {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                }
            `,
        },
    },
} as xBaseTheme["overflowMenu"];
